import OpenSeadragon from 'openseadragon'
import * as d3 from 'd3'
import { v4 as uuid } from 'uuid'

export default {
  init: function (viewer, rulerId) {
    viewer.trackerMouse = this.mouseTracker(viewer, rulerId)
    viewer.trackerMouse.setTracking(false)

    let rulerLabel = {
      labels: ['start', 'end', 'reset'],
      currentIndex: 0,
      nextLabel: function () {
        return this.labels[this.currentIndex++]
      }
    }
    let that = this
    viewer.addHandler('canvas-click', function clicked(event) {
      that.onCanvasClick(event, viewer, rulerLabel.nextLabel(), rulerId)
    })
  },
  onCanvasClickSetup: function (viewer, rulerDom) {
    const rulerId = uuid()
    viewer.addHandler('rulerEnabled', () => {
      this.init(viewer, rulerId)
    })
    viewer.addHandler('rulerDisabled', () => {
      this.destroy(viewer, rulerId)
    })

    document.addEventListener('resetOtherRulersRulers', e => {
      if (e.detail !== viewer.element.id) {
        this.reset(viewer, rulerId)
      }
    })

    rulerDom.addEventListener('click', function () {
      if (rulerDom.classList.contains('active')) {
        viewer.raiseEvent('rulerEnabled', {})
      } else {
        viewer.raiseEvent('rulerDisabled', {})
      }
    })
  },
  mouseTracker: function (viewer, rulerId) {
    let that = this
    return new OpenSeadragon.MouseTracker({
      element: viewer.container,
      moveHandler: function (event) {
        const webPointOnMove = event.position
        that.removeSvg(viewer, rulerId)
        that.drawRuler(viewer, webPointOnMove, rulerId)
      }
    })
  },
  onCanvasClick: function (event, viewer, markerLabel, rulerId) {
    if (markerLabel === 'reset') {
      viewer.raiseEvent('rulerDisabled', {})
      this.reset(viewer, rulerId)
      return
    }

    document.dispatchEvent(new CustomEvent('resetOtherRulersRulers', { detail: viewer.element.id }))

    let webPoint = event.position
    let viewportPoint = viewer.viewport.pointFromPixel(webPoint)
    viewer.trackerMouse.setTracking(markerLabel === 'start')

    this.drawMarker(viewer, viewportPoint, markerLabel, rulerId)
  },
  drawMarker: function (viewer, viewportPoint, label, rulerId) {
    const marker = document.createElement('div')
    marker.id = `rulerMarker-${label}-${rulerId}`
    marker.classList.add('rulerMarker')

    viewer.addOverlay({
      element: marker,
      location: viewportPoint,
      placement: OpenSeadragon.Placement.CENTER
    })
  },
  drawDistanceText: function (viewer, viewportPoint, dist, i) {
    const rect = document.createElement('div')
    rect.id = 'distanceText' + i
    rect.classList.add('distanceText')
    rect.innerHTML = dist.cm.toFixed(2) + ' cm - ' + dist.inc.toFixed(2) + ' in'

    viewer.addOverlay({
      element: rect,
      location: viewportPoint,
      placement: OpenSeadragon.Placement.CENTER
    })
  },
  drawLine: function (viewer, firstMarker, secondMarker, uniqueId) {
    let mult = 100
    const svg_overlay = viewer.svgOverlay()
    const overlay = d3.select(svg_overlay.node())
    overlay
      .append('line')
      .attr('id', 'rulerLineSvg' + uniqueId)
      .attr('stroke', '#cccccc')
      .attr('x1', secondMarker.x * mult)
      .attr('y1', secondMarker.y * mult)
      .attr('x2', firstMarker.x * mult)
      .attr('y2', firstMarker.y * mult)
      .style('stroke-width', '2px')
      .style('vector-effect', 'non-scaling-stroke')
      .style('stroke-dasharray', '3px, 3px')
  },
  drawRuler: function (viewer, current, rulerId) {
    const firstMarker = viewer.currentOverlays[0].location
    const secondMarker = viewer.viewport.pointFromPixel(current)
    const distance = this.calcDistance(viewer, firstMarker, secondMarker)

    this.drawLine(viewer, firstMarker, secondMarker, rulerId)
    const position = new OpenSeadragon.Point((firstMarker.x + secondMarker.x) / 2, (firstMarker.y + secondMarker.y) / 2)
    this.drawDistanceText(viewer, position, distance, rulerId)
  },
  calcDistance: function (viewer, firstMarker, secondMarker) {
    const image = viewer.world.getItemAt(0)
    const firstMarkerCoordinates = image.viewportToImageCoordinates(firstMarker)
    const secondMarkerCoordinates = image.viewportToImageCoordinates(secondMarker)
    const h = Math.abs(secondMarkerCoordinates.y - firstMarkerCoordinates.y)
    const b = Math.abs(secondMarkerCoordinates.x - firstMarkerCoordinates.x)
    const d = Math.sqrt(Math.pow(h, 2) + Math.pow(b, 2))
    return { cm: (d / viewer.ppi) * 2.54, inc: d / viewer.ppi }
  },
  destroy: function (viewer, rulerId) {
    if (viewer.trackerMouse) {
      viewer.trackerMouse.setTracking(false)
    }
    viewer.removeAllHandlers('canvas-click')
    this.removeSvg(viewer, rulerId)
    this.removeMarkers(viewer, rulerId)
  },
  reset: function (viewer, rulerId) {
    this.destroy(viewer, rulerId)
    this.init(viewer, rulerId)
  },
  removeSvg: function (viewer, rulerId) {
    viewer.removeOverlay('labelRuler' + rulerId)
    viewer.removeOverlay('distanceText' + rulerId)
    d3.select('#rulerLineSvg' + rulerId).remove()
    d3.select('#rulerTextSvg').remove()
    d3.select('#labelRuler').remove()
  },
  removeMarkers: function (viewer, rulerId) {
    viewer.removeOverlay('rulerMarker-start-' + rulerId)
    viewer.removeOverlay('rulerMarker-end-' + rulerId)
  },

  setupRulerToggleButton(rulerDom) {
    rulerDom.addEventListener('click', function () {
      if (!rulerDom.classList.contains('active')) {
        rulerDom.classList.add('active')
      } else {
        rulerDom.classList.remove('active')
      }
    })
  }
}
